import {
    Component,
    OnInit,
    OnDestroy,
    DoCheck,
    Input,
    ElementRef,
    ViewChild,
} from '@angular/core';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { SessionService } from '../../session-service/session.service';
import { ToastrService, LoadingIndicatorService } from '@kpmg-tax/ui';
import { SelectedItems } from '../../models/add-activities-projects.model';
import { BaseResponse } from '../../models/base-response.model';
import { Messages } from '../../constants/messages';
import { EngagementInsigtsService } from 'src/app/engagement-insights/engagement-insights.service';
import { Observable, of } from 'rxjs';
import {
    catchError,
    debounceTime,
    distinctUntilChanged,
    switchMap,
    tap,
} from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CreateStudyService } from '../create-study/services/create-study.service';
//import { HomeCreateNewEngagementService } from '../home-create-new-engagement/home-create-new-engagement.service';

@Component({
    selector: 'assign-bulk-sme',
    templateUrl: './assign-bulk-sme.component.html',
    styleUrls: ['../assign-bulk-SMEs/assign-bulk-sme.component.scss'],
})
export class AssignBulkSurveyToSMEComponent
    implements OnInit, OnDestroy, DoCheck {
    rowData: any[];
    selectAll: boolean = false;
    engagementId: any;
    isAddDisabled: boolean = true;
    selectedSurveys: any[] = [];
    unAssignedsurveys: any[];
    unAssignedsurveysbckup: any[];
    filteredSMEs: any[];
    activeSurveyIndex: number = null;
    clientId: any;
    SMESearchClickCount: number = 0;
    @ViewChild('SMESearch', { static: true }) SMESearch: ElementRef;
    @ViewChild('SMETypeAhead', { static: true }) SMETypeAhead;
    targetForm: FormGroup;
    noResults: boolean = false;
    selectedSME: string | undefined;
    isSelected: boolean = false;
    selectedSMEId: any;
    selectedSMEEmail: string;
    clientName: string;
    kpmgUsers: any;

    constructor(
        public rightSideDrawerService: RightSideDrawerService,
        public sessionService: SessionService,
        public toastrService: ToastrService,
        private formBuilder: FormBuilder,
        public engagementInsightService: EngagementInsigtsService,
        //private _homeCreateNewEngagementService: HomeCreateNewEngagementService,
        private _createStudyService: CreateStudyService) {
        this.engagementId = this.sessionService.getSession('engagementId');
        this.clientId = this.sessionService.getSession('clientId');
    }

    ngOnInit() {
        this.getUnAssignedSurveys();
        this.targetForm = this.formBuilder.group({
            smeSearch: [''],
        });
        //this.setProperties();
        this.clientName = this.sessionService.getSession('clientName');
        this.getKPMGUsers();
    }

    setProperties() {
        setTimeout(() => {
            this.targetForm.patchValue({
                smeSearch: this.selectedSME,
            });
        });
    }

    getUnAssignedSurveys() {
        let unAssignedsurveys = this.engagementInsightService
            .getUnAssignedSurveys(this.engagementId, this.clientId)
            .subscribe((data: any) => {
                this.filteredSMEs = data.result.smEs;
                this.unAssignedsurveys = data.result.surveys;
                this.unAssignedsurveysbckup = JSON.parse(
                    JSON.stringify(data.result.surveys),
                );
            });
    }

    SetSurveys(survey, event, index) {
        if (event.target.checked) {
            let item = {
                SurveyId: survey.surveyId,
                SurveyName: survey.surveyName,
            };
            this.selectedSurveys.push(item);
            this.unAssignedsurveys.splice(index, 1);
            this.activeSurveyIndex = index;
            if (this.unAssignedsurveys.length === 0) {
                this.selectAll = true;
            }
        }

        this.enableAssign();
    }

    UnSetSurveys(survey, event, index) {
        const found = this.unAssignedsurveys.some(
            el => el.surveyId === survey.SurveyId,
        );
        if (!found) {
            let survey1 = {
                surveyId: survey.SurveyId,
                surveyName: survey.SurveyName,
            };
            this.unAssignedsurveys.push(survey1);
            this.selectedSurveys.forEach((item, index) => {
                if (item.SurveyId === survey.SurveyId) {
                    this.selectedSurveys.splice(index, 1);
                }
            });
        }
        if (this.unAssignedsurveys.length === 0) {
            this.selectAll = true;
        } else {
            this.selectAll = false;
        }
        this.enableAssign();
    }

    searchSMEStream = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            debounceTime(150), // Wait 150 milliseconds for typing to stop
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
            }),
            switchMap(term => {
                // Process the search term entered
                if (this.clientName != 'KPMG Demo') {
                    return this.searchSMEs(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (this.clientName == 'KPMG Demo') {
                    return this.searchDemoClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else {
                    return of([]);
                }

            }),
        )

    public searchSMEs(term: string): Observable<any> {
        let searchData = this.filteredSMEs.filter(x => !!x.userId);
        return of(
            searchData.filter(item =>
                item.displayName.toLowerCase().includes(term.toLowerCase()),
            ),
        );
    }
    public searchDemoClientUsers(term: string): Observable<any> {
        let searchData = this.filteredSMEs.filter(x => !!x.userId);
        let kpmgUserdata: any[] = this.kpmgUsers;
        let searchDemoClientuser = kpmgUserdata.concat(searchData);
        if (searchData == null && kpmgUserdata == null) {
            return of([]);
        } else if (searchData == null && kpmgUserdata != null) {
            return of(
                kpmgUserdata.filter(item =>
                    item.displayName.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        } else if (searchData != null && kpmgUserdata == null) {
            return of(
                searchData.filter(item =>
                    item.displayName.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        } else {
            return of(
                searchDemoClientuser.filter(item =>
                    item.displayName.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        }

    }
    AssignBulk = () => {
        this.isAddDisabled = true;
        let surveyData = {
            RespondentId: this.selectedSMEId,
            EngagementId: this.engagementId,
            RespondentName: this.selectedSME,
            RespondentEmail: this.selectedSMEEmail,
            assignedSurveys: this.selectedSurveys,
        };
        this.engagementInsightService.assignBulkSME(surveyData).subscribe(
            data => {
                if (data !== null && data.success) {
                    this.toastrService.setSuccessMessage(Messages.Bulk_Assign_SME);
                    this.engagementInsightService.refreshTable(true);
                    this.rightSideDrawerService.closeRightSideDrawer();
                } else {
                    this.isAddDisabled = false;
                    this.toastrService.setErrorMessage('Failed to assign SME');
                }
            },
            error => {
                this.isAddDisabled = false;
                // If request fails,  give an error.
                this.toastrService.setErrorMessage('Failed to assign SME');
            },
        );
    }

    SelectAll = event => {
        if (event.target.checked) {
            this.selectAll = true;
            this.selectedSurveys = [];
            this.unAssignedsurveysbckup.forEach((x: any, index) => {
                this.selectedSurveys.push({
                    SurveyId: x.surveyId,
                    SurveyName: x.surveyName,
                });
            });
            this.unAssignedsurveys = [];
            this.enableAssign();
        } else {
            this.unAssignedsurveys = [...this.unAssignedsurveysbckup];
            this.selectedSurveys = [];
            this.selectAll = false;
            this.enableAssign();
        }
    }
    enableAssign() {
        if (
            this.selectedSurveys.length !== 0 &&
            this.selectedSME != null &&
            this.selectedSME !== ''
        ) {
            this.isAddDisabled = false;
        } else {
            this.isAddDisabled = true;
        }
    }
    ngDoCheck() {
        if (this.selectedSurveys.length !== 0 || this.selectedSME != null) {
            this.rightSideDrawerService.setMandatoryField(
                true,
                'Bulk Assignment Survey',
            );
        } else {
            this.rightSideDrawerService.setMandatoryField(false, '');
        }
    }
    onSMEFilter(event) {
        this.selectedSME = event.item.displayName;
        this.selectedSMEId = event.item.userId;
        this.selectedSMEEmail = event.item.email;
        //this.targetForm.controls.smeSearch.value=event.item.userName;
        this.enableAssign();
        this.smeSearch();
        //this.setProperties();
    }
    smeSearch() {
        if (this.selectedSME === undefined) {
            return '';
        } else if (this.selectedSME !== null) {
            return this.selectedSME;
        } else {
            return '';
        }
    }
    clearSME() {
        this.selectedSME = '';
        this.selectedSMEId = '';
        this.selectedSMEEmail = '';
        this.noResults = false;
        this.enableAssign();
    }
    getKPMGUsers(): void {
        this._createStudyService.kpmgUsersDataSource$.subscribe(kpmgUsersResponse => {
            if (kpmgUsersResponse && kpmgUsersResponse.result) {
                this.kpmgUsers = kpmgUsersResponse;
            }
        });
    }
    ngOnDestroy() {
        this.rightSideDrawerService.closeRightSideDrawer();
    }
}
